<template>
  <b-row>
    <b-col cols="1"></b-col>
    <b-col>
      <b-overlay :show="quesTypeLoading">
        <b-card no-body>
          <b-card-header class="p-3 bg-white">
            <b-button @click="$emit('back')" class="float-left" variant="outline-primary">
              <i class="fa fa-arrow-left"></i>
              {{ $t("actions.back") }}
            </b-button>
            <h3 class="text-center text-primary">
              <strong>{{ $t("actions.addQuestion") }}</strong>
            </h3>
          </b-card-header>
          <div>
            <div class="pl-5 pt-3 pr-5">
              <b-row>
                <b-col>
                  <b-form>
                    <b-row>
                      <!-- NAME EN-->
                      <b-col lg="2">
                        <label>{{ $t("savol.en") }}</label>
                      </b-col>
                      <b-col lg="10">
                        <b-form-textarea
                          size="xl"
                          class="mr-sm-2 mb-sm-0 forAddCandidate"
                          type="text"
                          @input="($event) => (form.nameUz = $toCyrill($event))"
                          v-model="$v.form.nameLt.$model"
                          aria-describedby="input-1-live-feedback"
                          :state="validateState('nameLt')"
                          rows="3"
                        ></b-form-textarea>
                        <b-form-invalid-feedback
                          class="invalid"
                          id="input-1-live-feedback"
                          >{{ $t("error.name_error") }}
                        </b-form-invalid-feedback>
                      </b-col>
                      <!-- NAME UZ -->
                      <b-col lg="2" class="mt-2">
                        <label>{{ $t("savol.uz") }}</label>
                      </b-col>

                      <b-col lg="10" class="mt-2">
                        <b-form-textarea
                          rows="3"
                          size="xl"
                          class="mr-sm-2 mb-sm-0 forAddCandidate"
                          type="text"
                          @input="($event) => (form.nameLt = $toLatin($event))"
                          v-model="$v.form.nameUz.$model"
                          aria-describedby="input-3-live-feedback"
                          :state="validateState('nameUz')"
                        ></b-form-textarea>
                        <b-form-invalid-feedback
                          class="invalid"
                          id="input-3-live-feedback"
                          >{{ $t("error.name_error") }}
                        </b-form-invalid-feedback>
                      </b-col>
                      <!-- NAME RU -->
                      <b-col lg="2" class="mt-2">
                        <label>{{ $t("savol.ru") }}</label>
                      </b-col>
                      <b-col lg="10" class="mt-2">
                        <b-form-textarea
                          rows="3"
                          size="xl"
                          class="mr-sm-2 mb-sm-0 forAddCandidate"
                          type="text"
                          v-model="$v.form.nameRu.$model"
                          aria-describedby="input-2-live-feedback"
                          :state="validateState('nameRu')"
                        ></b-form-textarea>
                        <b-form-invalid-feedback
                          class="invalid"
                          id="input-2-live-feedback"
                          >{{ $t("error.name_error") }}
                        </b-form-invalid-feedback>
                      </b-col>
                      <b-col lg="2" class="mt-2">
                        <label>{{ $t("savol.kr") }}</label>
                      </b-col>
                      <b-col lg="10" class="mt-2">
                        <b-form-textarea
                          rows="3"
                          size="xl"
                          class="mr-sm-2 mb-sm-0 forAddCandidate"
                          type="text"
                          v-model="$v.form.nameKr.$model"
                          aria-describedby="input-2-live-feedback"
                          :state="validateState('nameKr')"
                        ></b-form-textarea>
                        <b-form-invalid-feedback
                          class="invalid"
                          id="input-2-live-feedback"
                          >{{ $t("error.name_error") }}
                        </b-form-invalid-feedback>
                      </b-col>
                      <b-col class="mt-4" cols="12">
                        <b-form-group
                          :label="$t('permissions.type') + ' *'"
                          label-cols-sm="3"
                        >
                          <div class="d-flex">
                            <vue-select
                              style="width: 100%"
                              class="style-choose"
                              :label="$localeKey()"
                              :options="questionTypeList"
                              :class="{ error: $v.form.questionTypeId.$anyError }"
                              v-model="form.questionTypeId"
                              :reduce="el=>el.id"
                            >
                              <template #no-options>
                                {{ $t("warning.noInformation") }}
                              </template>
                            </vue-select>
                            <b-button class="ml-2" @click="quesTypeAddShow = true">
                              <i class="fas fa-plus"></i
                            ></b-button>
                            <b-button
                              v-if="form.questionTypeId"
                              variant="danger"
                              class="ml-2"
                              @click="deleteSelectedType"
                            >
                              <i class="fas fa-trash"></i
                            ></b-button>
                          </div>
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </b-form>
                </b-col>
              </b-row>
            </div>

            <div class="pl-5 pr-5 pt-2 pb-3">
              <b-row>
                <b-col cols="2">
                  <label class="mt-3">{{ $t("actions.uploadImage") }}</label>
                </b-col>
                <b-col cols="4">
                  <b-form-file
                    class="mt-4"
                    v-model="form.file"
                    :placeholder="$t('warning.noChoosen')"
                    size="xl"
                    accept="image/*"
                    ref="fileRef"
                  ></b-form-file>
                </b-col>
              </b-row>
            </div>
          </div>
        </b-card>
      </b-overlay>

      <b-card no-body class="mt-2">
        <div class="pt-4 pl-4 pr-4 pb-4">
          <b-row>
            <b-col>
              <b-button @click="isAdd = true" class="float-right" variant="primary">
                <i class="fa fa-plus"></i>
                {{ $t("Variant qo'shish") }}
              </b-button>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="6" md="6" sm="12" v-for="(item, index) in options" :key="index">
              <b-alert :variant="item.isAnswer ? 'success' : 'warning'" :show="true">
                <div
                  style="
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                  "
                >
                  <div>
                    <p>
                      {{ $t("lang.uzbekLatin") }}:
                      <strong>{{ item.nameLt }}</strong>
                    </p>
                    <p>
                      {{ $t("lang.uzbekKrill") }}: <strong>{{ item.nameUz }}</strong
                      >,
                    </p>
                    <p>
                      {{ $t("lang.russian") }}: <strong>{{ item.nameRu }}</strong
                      >,
                    </p>
                    <p>
                      {{ $t("lang.kr") }}: <strong>{{ item.nameKr }}</strong
                      >,
                    </p>
                  </div>
                  <div>
                    <b-button @click="deleteByIndex(index)" variant="outline-danger">
                      <i class="fa fa-times"></i>
                    </b-button>
                  </div>
                </div>
              </b-alert>
            </b-col>
          </b-row>
        </div>

        <b-card-footer class="bg-white">
          <b-row>
            <b-col>
              <b-button @click="create" class="float-right" variant="success">
                <i class="fa fa-save"></i>
                {{ $t("actions.save") }}
              </b-button>
            </b-col>
          </b-row>
        </b-card-footer>
      </b-card>
    </b-col>
    <b-col cols="1"></b-col>

    <b-modal
      @ok="okVariant"
      hide-header
      :ok-title="$t('actions.add')"
      :cancel-title="$t('actions.cancel')"
      v-model="isAdd"
      size="md"
    >
      <div>
        <b-row>
          <b-col>
            <div class="p-4">
              <div>
                <b-row>
                  <b-col cols="12">
                    <label for="name">{{ $t("variant.en") }}</label>
                    <input
                      id="name"
                      v-model="field.nameLt"
                      type="text"
                      name="untyped-input"
                      class="form-control"
                    />
                  </b-col>
                  <b-col cols="12">
                    <label for="name">{{ $t("variant.uz") }}</label>
                    <input
                      id="name"
                      v-model="field.nameUz"
                      type="text"
                      name="untyped-input"
                      class="form-control"
                    />
                  </b-col>
                  <b-col cols="12">
                    <label for="name">{{ $t("variant.ru") }}</label>
                    <input
                      id="name"
                      v-model="field.nameRu"
                      type="text"
                      name="untyped-input"
                      class="form-control"
                    />
                  </b-col>
                  <b-col cols="12">
                    <label for="name">{{ $t("variant.kr") }}</label>
                    <input
                      id="name"
                      v-model="field.nameKr"
                      type="text"
                      name="untyped-input"
                      class="form-control"
                    />
                  </b-col>
                  <b-col>
                    <b-form-checkbox
                      size="lg"
                      class="mt-3"
                      v-model="field.isAnswer"
                      name="check-button"
                      switch
                    >
                      <strong style="font-size: 15px">{{ $t("Tog`ri javob") }}</strong>
                    </b-form-checkbox>
                  </b-col>
                  <b-col cols="12">
                    <label for="name">{{ $t("File") }}</label>
                    <b-form-file v-model="field.file"></b-form-file>
                  </b-col>
                </b-row>
              </div>
            </div>
          </b-col>
        </b-row>
      </div>
    </b-modal>
    <b-modal
      @ok="addQuesType"
      hide-header
      :ok-title="$t('actions.add')"
      :cancel-title="$t('actions.cancel')"
      v-model="quesTypeAddShow"
      size="md"
    >
      <b-overlay :show="quesTypeLoading">
        <b-row>
          <b-col>
            <div class="p-4">
              <div>
                <b-row>
                  <b-col cols="12">
                    <label for="name">{{ $t("name.en") }}</label>
                    <b-form-input
                      :state="validateState2('nameLt')"
                      @input="($event) => (quesType.nameUz = $toCyrill($event))"
                      v-model="quesType.nameLt"
                      type="text"
                      name="untyped-input"
                      class="form-control"
                    />
                  </b-col>
                  <b-col cols="12">
                    <label for="name">{{ $t("name.uz") }}</label>
                    <b-form-input
                      :state="validateState2('nameUz')"
                      v-model="quesType.nameUz"
                      @input="($event) => (quesType.nameLt = $toLatin($event))"
                      type="text"
                      name="untyped-input"
                      class="form-control"
                    />
                  </b-col>
                  <b-col cols="12">
                    <label for="name">{{ $t("name.ru") }}</label>
                    <b-form-input
                      :state="validateState2('nameRu')"
                      v-model="quesType.nameRu"
                      type="text"
                      name="untyped-input"
                      class="form-control"
                    />
                  </b-col>
                  <b-col cols="12">
                    <label for="name">{{ $t("name.kr") }}</label>
                    <b-form-input
                      :state="validateState2('nameKr')"
                      v-model="quesType.nameKr"
                      type="text"
                      name="untyped-input"
                      class="form-control"
                    />
                  </b-col>
                </b-row>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-overlay>
    </b-modal>
  </b-row>
</template>

<script lang="js">
import {validationMixin} from "vuelidate";
import {required} from "vuelidate/lib/validators";
import {mapActions, mapState} from 'vuex'
import vacancyService from '@/services/vacancy.service'
import QuestTypeService from "@/services/reference/question-type.service"
export default {
  props : {
    item : {
      default : ()=>{}
    },
    mode : {
      default : "create"
    }
  },
  mixins: [validationMixin],
  name: 'add-update',
  data() {
    return {
      field: {
        nameUz: null,
        nameLt: null,
        nameRu: null,
        nameKr: null,
        file: null,
        isAnswer: false
      },
      isAdd: false,
      form: {
        nameLt: "",
        nameRu: "",
        nameUz: "",
        nameKr: "",
        file: null,
        type: null,
        questionTypeId : null,
      },
      options: [],
      questionTypeList : [],
      quesType : {
        nameUz : "",
        nameRu : "",
        nameLt : "",
        nameKr : "",
      },
      quesTypeLoading : false,
      quesTypeAddShow : false
    }
  },
  validations: {
    form: {
      nameLt: {
        required
      },
      nameRu: {
        required
      },
      nameUz: {
        required
      },
      nameKr: {

      },
      questionTypeId : {
        required
      }
    },
    field: {
      nameLt: {
        required
      },
      nameRu: {
        required
      },
      nameUz: {
        required
      },
      nameKr: {

      }
    },
    quesType : {
        nameUz : {
          required
        },
        nameRu : {
          required
        },
        nameLt : {
          required
        },
        nameKr : {
          required
        },
      },
  },
  methods: {
    async deleteSelectedType(){
      if(confirm("Tanlangan savol turini o'chirmoqchimisiz?")){
        await QuestTypeService.delete(this.form.questionTypeId)
        this.getQuesTypes()
        this.form.questionTypeId = null
      }
    },
 async addQuesType(b) {
      b.preventDefault()
      this.$v.quesType.$touch();
      if (!this.$v.field.$anyError) {
       try {
        this.quesTypeLoading = true
        this.quesTypeAddShow = false
        await QuestTypeService.create(this.quesType)
        this.getQuesTypes()
        this.quesType.nameKr = "" 
        this.quesType.nameUz = "" 
        this.quesType.nameRu = "" 
        this.quesType.nameLt = "" 
       }
       finally {
        this.quesTypeLoading = false
       }

      } else {
        this.$toast.error( this.$t( 'warning.enter' ) );
      }

    },
   async getQuesTypes(){
    let res = await QuestTypeService.getList()
    this.questionTypeList = res.data

   },
    deleteByIndex(index) {
      this.options.splice( index, 1 )
    },
    okVariant(b) {
      b.preventDefault()
      this.$v.field.$touch();
      if (!this.$v.field.$anyError) {
        if (this.options.length > 0) {
          if (this.options.find( el => el.isAnswer && this.field.isAnswer )) {
            this.$toast.error( this.$t( 'To`gri javob tanlangan' ) );
            return
          }
        }
        let copy = {...this.field}
        this.options.push( copy );
        this.field.nameLt = null
        this.field.nameUz = null
        this.field.nameRu = null
        this.field.nameKr = null
        this.field.file = null
        this.field.isAnswer = false
        this.isAdd = false
      } else {
        this.$toast.error( this.$t( 'warning.enter' ) );
      }

    },
    async create() {
      let res = await this.checkValidity()
      if (!res && this.options.length > 0) {
        if (this.options.find( e => e.isAnswer )) {

          let payload = {
            ...this.form,
            answers: this.options
          }
          let action = this.mode =='update' ? 'updateQuestion' : 'createQuestion'
          await vacancyService[action]( payload )
          await this.$emit( 'back' )
        } else {
          this.$toast.error( 'Tog`ri javob tanlanmagan' )
        }
      } else {
        this.$toast.info( this.$t( 'warning.dataIncomplate' ) )
      }
    },
    validateState(name) {
      const {$dirty, $error} = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    validateState2(name) {
      const {$dirty, $error} = this.$v.quesType[name];
      return $dirty ? !$error : null;
    },
    checkValidity() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return true;
      } else {
        return false
      }
    },
  },
  computed: {
    ...mapState( "testcrud", ["selectedDepsId"] ),
  },
  mounted() {
    this.getQuesTypes()
    if(this.mode=='update'){
      this.form.nameUz = this.item.nameUz
      this.form.nameRu = this.item.nameRu
      this.form.nameLt = this.item.nameLt
      this.form.nameKr = this.item.nameKr
      this.form.type = this.item.type
      this.form.questionTypeId = this.item.questionTypeId
      this.options = this.item.answers
      this.form.id = this.item.id
    }
  },
}
</script>

<style lang="scss">
.mts {
  margin-top: 12px;
}

.forAddCandidate {
  font-size: 0.9rem !important;

  .form-control.form-control-lg {
    padding: 0.2rem 0.75rem !important;
  }
}

.invalid {
  font-size: 9px;
}

.theme--light.v-input input {
  color: blue !important;
}

.card-1:hover {
  cursor: pointer;
  // box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);
}

.card-1 {
  background: #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100px;
  height: 100px;
  border: 1px dashed rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  font-size: 10px !important;
  // box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  // transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
}

.card-2 {
  width: 52px;
  height: 52px;
}
</style>
